<template>
  <b-row>
    <b-col md="6">

      <b-card
          class="card-transaction"
          no-body
      >

        <b-card-body>

          <content-document
              v-if="'id' in order && order.number != null"
              :document="{extension: 'pdf', name: $t('PurchaseOrder')}"
              :isDeletable="false"
          />

          <content-document
              v-for="(document, index) in order.documents"
              :document="document"
              @delete="deleteDocument(index)"
          />

        </b-card-body>
      </b-card>

    </b-col>

    <b-col md="6">
      <field-file
          :singleFile.sync="newDocument"
          :documentType="'order'"
          :resetAfterUploaded="true"
      />
    </b-col>

  </b-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import ContentDocument from '@/components/card/components/DocumentContent'
import FieldFile from '@/components/input/File'

export default {
  components: {
    ContentDocument,
    FieldFile
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const newDocument = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(newDocument, (val) => {
      // console.log(val)
      if (val != null) {
        props.order.documents.splice(props.order.documents.length, 0, val)
      }
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const deleteDocument = (index) => {
      props.order.documents.splice(index, 1)
    }

    const download = (documentToDownload = null) => {
      console.log(documentToDownload)
      // if (documentToDownload == null) {
      //   // Purchase order
      //   emit('downloadOrder', props.order)
      // } else {
      //   let link = document.createElement('a')
      //   link.setAttribute('target', '_blank')
      //   link.href = documentToDownload.url
      //   link.click()
      // }
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data
      newDocument,

      // Computed

      // Methods
      deleteDocument,
      download,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>